import { IPrimaryArea } from '../../interfaces/components/input.interface';

const PrimaryTextArea: React.FC<IPrimaryArea> = ({
  icon,
  desc,
  classname,
  setValue,
  value,
  error = false,
  isObject = false,
  inputName = '',
  iconClass,
  maxLength = true
}) => {
  return (
    <main
      className={`${classname} px-3 border   ${
        error
          ? 'border-red-500 focus-within:border-gray-300'
          : 'border-gray-300 focus-within:border-sky-500'
      } rounded-lg flex items-start py-4 justify-start gap-3`}
    >
      {icon && (
        <p
          className={`bg-[#2691BD1A] text-primary ${iconClass} text-lg p-1 rounded-md`}
        >
          {icon}
        </p>
      )}
      <textarea
        rows={6}
        maxLength={maxLength ? 256 : undefined}
        onChange={(e) => {
          isObject
            ? setValue(e.target.name, e.target.value)
            : setValue(e.target.value);
        }}
        className="text-gray-600 focus:outline-none flex-1 placeholder:text-[#C4C4C4] placeholder:font-light"
        placeholder={desc}
        value={value}
        name={inputName}
      />
    </main>
  );
};

export default PrimaryTextArea;
